import createXRControls from "./XRControls";
import * as THREE from 'three'
import { XRControllerModelFactory } from 'three/examples/jsm/webxr/XRControllerModelFactory'
import { XRHandModelFactory } from 'three/examples/jsm/webxr/XRHandModelFactory.js'


const XRControls = createXRControls(THREE, XRControllerModelFactory, XRHandModelFactory)

export default class Controls extends THREE.EventDispatcher {

    constructor(props) {
        super()
        this.scene = props.scene
        this.camera = props.camera
        this.sceneContainer = props.sceneContainer
        this.options = props.options
        this.renderer = props.renderer
        this.xrOptions = props.xrOptions
        this.intersectableObjects = []

        this.bindings.call(this)
        this.init()
    }

    bindings() {
        this.selectStart = this.selectStart.bind(this)
        this.rayMove = this.rayMove.bind(this)
        this.selectEnd = this.selectEnd.bind(this)
        this.rightClick = this.rightClick.bind(this)
        this.keyUp = this.keyUp.bind(this)
        this.keyDown = this.keyDown.bind(this)
        this.scroll = this.scroll.bind(this)
        this.hideTouchKeyboard = this.hideTouchKeyboard.bind(this)
        this.showTouchKeyboard = this.showTouchKeyboard.bind(this)
    }


    init() {
        this.xrControls = new XRControls(this, this.xrOptions)
        this.xrControls.addEventListener('rightClick', this.rightClick)
        this.xrControls.addEventListener('selectStart', this.selectStart)
        this.xrControls.addEventListener('selectEnd', this.selectEnd)
        this.xrControls.addEventListener('rayMove', this.rayMove)
        this.xrControls.addEventListener('scroll', this.scroll)
    }

    update() {
        this.dispatchEvent({ type: 'update' })
    }

    removeControls() {
        if (this.touchKeyboard) this.touchKeyboard.remove()
        if (this.mouseControls) this.mouseControls.remove()
        if (this.touchControls) this.touchControls.remove()
        if (this.keyboardControls) this.keyboardControls.remove()
        if (this.xrControls) this.xrControls.destroy()
    }

    rightClick(evt) {
        const { raycaster } = this
        if (!raycaster) return
        this.selecting = false
        this.dispatchEvent({ type: 'selectStart', data: { method: 'rightclick', raycaster: this.raycaster, evt } })
    }

    selectStart(evt) {
        if (this.selecting) return
        this.selecting = true
        const raycaster = evt.data.raycaster
        if (raycaster) this.raycaster = raycaster
        const { intersect, intersects } = this.checkRayForIntersect()
        this.isTouch = false
        if (evt && evt.data && evt.data.evt && evt.data.evt.type === 'touchstart') this.isTouch = true

        this.checkLongSelect()
        const event = { method: 'dragStart', raycaster: this.raycaster, intersect, intersects, evt }
        this.prevEvent = event
        this.dispatchEvent({ type: 'selectStart', data: event })
    }

    rayMove(evt) {
        const raycaster = evt.data.raycaster
        const controller = evt.data.controller
        this.raycaster = raycaster
        const { intersect, intersects } = this.checkRayForIntersect()
        this.intersect = intersect
        const event = { method: 'dragMove', raycaster: this.raycaster, intersect: this.intersect, intersects, evt, controller }
        this.dispatchEvent({ type: 'rayMove', data: event })
    }


    selectEnd(evt) {
        this.selecting = false

        if (this.longClickTimeout) clearTimeout(this.longClickTimeout)

        const event = { method: 'dragEnd', raycaster: this.raycaster, evt }
        this.dispatchEvent({ type: 'selectEnd', data: event })
        //long click to right click
        if (this.prevEvent && this.longClicking && this.intersect && this.intersect.uv) {
            this.longClicking = false
            const currentUv = new THREE.Vector2(this.intersect.uv.x, this.intersect.uv.y)
            const prevUv = new THREE.Vector2(this.prevEvent.intersect.uv.x, this.prevEvent.intersect.uv.y)
            const distance = new THREE.Vector2()
            distance.subVectors(prevUv, currentUv)
            const change = Math.abs(distance.x) + Math.abs(distance.y)
            if (change < 0.05) {
                this.dispatchEvent({ type: 'selectStart', data: { method: 'rightclick', raycaster: this.raycaster, evt } })
            }
        }
    }

    scroll(evt) {
        this.dispatchEvent({ type: 'scroll', data: { data: evt.data } })
    }

    keyUp(evt) {
        //nothing
    }

    keyDown(evt) {
        this.dispatchEvent({ type: 'keyEvent', data: { method: 'keydown', evt } })
    }

    toggleTouchKeyboard() {
        if (this.touchKeyboard.showing) this.touchKeyboard.remove()
        else this.touchKeyboard.create()
    }

    toggleKeyboard() {
        this.keyboard.position.set(0, 0, 0)
        this.keyboard.rotation.set(0, 0, 0)
        if (this.keyboard.showing) this.keyboard.remove()
        else this.keyboard.create()
    }

    showTouchKeyboard() {
        this.touchKeyboard.create()
    }

    hideTouchKeyboard() {
        this.touchKeyboard.remove()
    }

    checkRayForIntersect() {
        try {
            const raycaster = this.raycaster
            if (!raycaster) {
                console.warn('no raycaster')
                return { intersect: null, intersects: null }
            }
            const intersects = raycaster.intersectObjects(this.intersectableObjects, true)
            if (intersects.length > 0) {
                const intersect = intersects[0]
                return { intersect, intersects }
            } else {
                this.intersect = null
                return { intersect: null, intersects: null }
            }
        } catch (e) {
            return { intersect: null, intersects: null }
        }
    }

    checkLongSelect() {
        if (this.longClickTimeout) {
            clearTimeout(this.longClickTimeout)
            this.longClickTimeout = null
        }
        this.longClicking = false
        this.longClickTimeout = setTimeout(() => {
            this.longClicking = true
        }, 1000)
    }

}